import { IOrganizationHoldingToken } from 'types/interfaces';

export const organizationsMock: IOrganizationHoldingToken[] = [
    {
        organization: {
            id: '0c621a01-8b6b-496b-b7db-0615b11b6662',
            title: 'UMA',
        },
        totalTokenValue: 181022.41471023785,
        totalTokenUsd: 1569807.8965612235,
    },
    {
        organization: {
            id: '1d732b12-9c7c-5a7c-c8ec-1726c22a7773',
            title: 'Compound',
        },
        totalTokenValue: 250000.987654321,
        totalTokenUsd: 3200000.123456789,
    },
    {
        organization: {
            id: '2e843c23-ad8d-6b8d-d9fd-2837d33b8884',
            title: 'Aave',
        },
        totalTokenValue: 300000.123456789,
        totalTokenUsd: 4500000.654321123,
    },
    {
        organization: {
            id: '3f954d34-be9e-7c9e-e0fe-3948e44c9995',
            title: 'Uniswap',
        },
        totalTokenValue: 420000.456789123,
        totalTokenUsd: 6300000.987654321,
    },
    {
        organization: {
            id: '4a065e45-cdaf-8daf-f10f-4a59f55daaaa',
            title: 'MakerDAO',
        },
        totalTokenValue: 380000.789123456,
        totalTokenUsd: 5700000.123456789,
    },
    {
        organization: {
            id: '5b176f56-dcb0-9eb0-0210-5b6a66ebbbbb',
            title: 'Synthetix',
        },
        totalTokenValue: 275000.321654987,
        totalTokenUsd: 4125000.456789123,
    },
    {
        organization: {
            id: '6c287g67-edc1-a1c1-1321-6c7b77fccccc',
            title: 'Yearn Finance',
        },
        totalTokenValue: 195000.654987321,
        totalTokenUsd: 2925000.789123456,
    },
    {
        organization: {
            id: '7d398h78-fed2-b2d2-2432-7d8c88gddddd',
            title: 'Curve Finance',
        },
        totalTokenValue: 225000.987321654,
        totalTokenUsd: 3375000.321654987,
    },
    {
        organization: {
            id: '8e4a9i89-gfe3-c3e3-3543-8e9d99heeeee',
            title: 'Balancer',
        },
        totalTokenValue: 175000.321987654,
        totalTokenUsd: 2625000.654987321,
    },
    {
        organization: {
            id: '9f5b0j90-hgf4-d4f4-4654-9f0ea0ifffff',
            title: 'Chainlink',
        },
        totalTokenValue: 500000.654321987,
        totalTokenUsd: 7500000.987321654,
    },
    {
        organization: {
            id: '0a6c1k01-ihg5-e5g5-5765-0a1fb1jggggg',
            title: 'Polygon',
        },
        totalTokenValue: 450000.987654321,
        totalTokenUsd: 6750000.321987654,
    },
    {
        organization: {
            id: '1b7d2l12-jih6-f6h6-6876-1b2gc2khhhhh',
            title: 'Solana',
        },
        totalTokenValue: 600000.123456789,
        totalTokenUsd: 9000000.654321123,
    },
    {
        organization: {
            id: '2c8e3m23-kji7-g7i7-7987-2c3hd3liiiii',
            title: 'Avalanche',
        },
        totalTokenValue: 350000.456789123,
        totalTokenUsd: 5250000.987654321,
    },
    {
        organization: {
            id: '3d9f4n34-lkj8-h8j8-8a98-3d4ie4mjjjjj',
            title: 'Fantom',
        },
        totalTokenValue: 280000.789123456,
        totalTokenUsd: 4200000.123456789,
    },
    {
        organization: {
            id: '4e0g5o45-mlk9-i9k9-9ba9-4e5jf5nkkkkk',
            title: 'Terra',
        },
        totalTokenValue: 320000.321654987,
        totalTokenUsd: 4800000.456789123,
    },
];
